import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AccountsService } from 'src/app/accounts/accounts.service';
import { AclToolsService } from '../tools/acl-tools.service';
import { AclResource } from '../tools/decorators/acl-resource';

export const ACL_RESOURCES = {
  MODERATION: 'bannerCampaignModeration',
  SEE_MODERATION: 'getBannerCampaignForModeration',
};

@Injectable({
  providedIn: 'root',
})
export class ModerationAclService {
  @AclResource(ACL_RESOURCES.MODERATION)
  public canModerate$: Observable<boolean>;

  @AclResource(ACL_RESOURCES.SEE_MODERATION)
  public canSeeModeration$: Observable<boolean>;

  constructor(
    public readonly aclTools: AclToolsService,
    private readonly accountsService: AccountsService,
  ) {}

  public canModerateCampaignByShop$(shopId: string): Observable<boolean> {
    return this.accountsService.publishers$
      .pipe(
        first(),
        map(publishers => {
          const publisher = publishers.find(publisher => publisher.id === shopId);
          if (!publisher) {
            return false;
          }

          const hasModeratePermission = this.aclTools.isAllowedForInstant([ACL_RESOURCES.MODERATION], publisher.id);

          if (hasModeratePermission) {
            return true;
          }

          const currentAccountId = this.aclTools.aclService.aclMapByAccountSnapshot;
          const isCurrentAccountContext = currentAccountId && currentAccountId[publisher.id];

          return !isCurrentAccountContext;
        }),
      );
  }
}
